import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @mui/material components
import {createUseStyles} from "react-jss";
import { Grid } from '@mui/material';

const styles = {
  grid: {
    padding: "0 15px !important"
  }
};

const useStyles = createUseStyles(styles);

export default function GridItem(props) {
  const classes = useStyles();
  const { children, className, ...rest } = props;
  return (
    <Grid item {...rest} className={classes.grid + " " + className}>
      {children}
    </Grid>
  );
}

GridItem.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};
